import React from "react";
import { Card } from "../../screens/LuckyNumbers/Home";
import { loadUpcomingDraws } from "../../redux/actions/sportTypesActions";
import { connect } from "react-redux";

class InfiniteScrollComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
    };
    this.itemsPerPage = 5;
    this.containerRef = React.createRef();
    this.isFetchingData = false;
  }

  fetchData = async () => {
    if (this.isFetchingData) return;
    const { connected, match, loadUpcomingDraws } = this.props;
    const { page } = this.state;

    try {
      console.log("fetch data");
      if (connected) {
        if (this.props.currentFilter == 1){
          let request = {
            Data: {
              Feed: { FeedId: Number(match.params.feed) },
              Sport: { SportId: Number(match.params.sport) },
              pageSize: 5,
              pageIndex: page + 1,
            },
          };
          this.isFetchingData = true;
          await loadUpcomingDraws(request, true);
          this.isFetchingData = false;
        } else if (this.props.currentFilter == 2){
          let request = {
            Data: {
              isTopBet: true,
              Feed: { FeedId: Number(match.params.feed) },
              Sport: { SportId: Number(match.params.sport) },
              pageSize: 5,
              pageIndex: page + 1,
            },
          };
          this.isFetchingData = true;
          await loadUpcomingDraws(request, true);
          this.isFetchingData = false;
        }else if (this.props.currentFilter == 3){
          let request = {
            Data: {
              isFavoriteTab: true,
              Feed: { FeedId: Number(match.params.feed) },
              Sport: { SportId: Number(match.params.sport) },
              pageSize: 5,
              pageIndex: page + 1,
            },
          };
          this.isFetchingData = true;
          await loadUpcomingDraws(request, true);
          this.isFetchingData = false;
        }
        this.setState((prevState) => ({ page: prevState.page + 1 }));


      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleScroll = () => {
    const container = this.containerRef.current;
    const scrollTolerance = 10; // Set a tolerance value to account for variations

    if (
      container.scrollLeft + container.clientWidth + scrollTolerance >=
      container.scrollWidth
    ) {
      this.fetchData();
    }
  };

  componentDidMount() {
    const container = this.containerRef.current;
    container.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    const container = this.containerRef.current;
    container.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    let data;
    if (
      this.props.upcomingDrawsEvents &&
      Object.values(this.props.upcomingDrawsEvents).length > 0
    ) {
      data = Object.values(this.props.upcomingDrawsEvents);
    }

    return (
      <div ref={this.containerRef} className="infinite-scroll-wrapper">
        {data &&
          data.map((item, idx) => {
            return (
              <div
                key={item.eventId}
                className="horizontal-scroll-item"
                style={{ display: "inline-block", width: 200, marginRight: 10 }}
              >
                <Card
                  item={item}
                  enableBet={item.enableBet}
                  key={item.eventId}
                  idx={idx}
                  name={item.eventTournament.tournamentDisplayName}
                  date={item.eventDateOfMatch}
                  flagCode={item.eventCategory.categoryFlagCode}
                  eventId={item.eventId}
                  match={this.props.match}
                  history={this.props.history}
                />
              </div>
            );
          })}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    loadingUpcomingDraws: state.sportTypes.loadingUpcomingDraws,
    upcomingDrawsEvents: state.sportTypes.upcomingDrawsEvents,
    upcomingDrawsEventsError: state.sportTypes.upcomingDrawsEventsError,
    connected: state.signalr.connected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadUpcomingDraws: (item, addNewList) => {
      dispatch(loadUpcomingDraws(item, addNewList));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfiniteScrollComponent);
